module.exports = __webpack_public_path__ + "assets/images/pregnant_g.bc2b53c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/pregnant_g.png
// module id = 757
// module chunks = 1